// utils/formatDateTime.ts
import moment from 'moment';

export const formatDateTime = (utcDate) => {
  const localDateTime = moment(utcDate).local(); // converts to local timezone
  const date = localDateTime.format('DD-MM-YYYY'); // or 'DD-MM-YYYY' as you prefer
  const time = localDateTime.format('hh:mm A');    // 12-hr format with AM/PM

  return { date, time };
};
